module.exports = __webpack_public_path__ + "problems.ada022ec56244e9194a7.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/agencehoffman/Desktop/Workspace/catherinet/src/app/assets/images/problems.jpg
// module id = ../../../../../src/app/assets/images/problems.jpg
// module chunks = main